import get from "./get";
import set from "./set";

/**
 * Get the only given keys from the given object
 *
 * @param {any} object
 * @param {Array<string>} keys
 * @returns {any}
 */
export default function only(object: any, keys: string[]): any {
    const newObject: Record<string, any> = {};

    for (const key of keys) {
        const value = get(object, key, undefined);

        if (value !== undefined) {
            set(newObject, key, value);
        }
    }

    return newObject;
}
